import React from "react";
import { useDispatch } from "react-redux";
import { URL_NOT_FOUND } from "../../actions/actionTypes";
import { useFileRemoval } from "../../helpers/useFileRemoval";
import ErrorPopup from "./ErrorPopup";

const UrlNotFound = ({
  errorInVerificationPoc,
  allFiles,
  setAllFiles,
  allProcessedFiles,
  setAllProcessedFiles
}) => {
  const dispatch = useDispatch();

  const { handleDelete, redirectToUpload } = useFileRemoval({
    allFiles,
    setAllFiles,
    allProcessedFiles,
    setAllProcessedFiles,
  });

  const onTryAgain = () => {
    dispatch({ type: URL_NOT_FOUND, payload: false });
    handleDelete();
    redirectToUpload();
  };

  return (
    <ErrorPopup onTryAgain={onTryAgain}>
      <div className="upload-title-text">
        Upload failed!
      </div>
      <div className="upload-content-text">
        {errorInVerificationPoc || "Please upload a recently downloaded version."}
      </div>
    </ErrorPopup>
  );
};

export default UrlNotFound;
